<div class="main-theme">
  <h1 class="visually-hidden">{{ "HOMEPAGE_TITLE" | translate }}</h1>
  <div class="container pt-3">
    <div class="row mt-5">
      <div class="col-12">
        <div class="card-space d-flex justify-content-center no-shadow">
          <div class="card card-bg">
            <div class="card-body card-body-padding">
              <div class="row mt-3">
                <div class="col-lg-6 col-12">
                  <div class="welcome-title">
                    {{ ("HELLO" | translate) + " " + nome }}
                  </div>
                  <p
                    class="welcome-prof-descr mt-3"
                    [innerHTML]="
                      welcomeCardDescr | translate | sanitizer : 'html'
                    "
                  ></p>
                </div>
                <div class="col-lg-6 col-12 my-3 d-flex justify-content-center">
                  <div
                    class="card-space d-flex justify-content-center col-12 col-lg-10"
                  >
                    <div class="card card-bg card-md card-role m-0">
                      <div
                        class="card-body card-body-custom d-flex align-items-center"
                      >
                        <div>
                          <div class="welcome-prof-descr title-card-role my-1">
                            {{ roleCardTitle | translate }}
                          </div>
                          <div class="mb-0 mb-1 subtitle-card-role">
                            {{ "ROLE" | translate | uppercase }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container
      *ngIf="
        !keycloakSrv.isUserInRole(userRoles.CITTADINO) ||
        keycloakSrv.isUserInRole(userRoles.PRESIDENTE)
      "
    >
      <div class="row mt-5">
        <div class="col-12">
          <h2>{{ "WHAT_U_CAN_DO" | translate }}</h2>
          <hr aria-hidden="true" />
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-12">
          <app-card-list [cardListConfig]="cardListConfig"></app-card-list>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- Strumenti utili -->
  <app-strumenti-utili
    *ngIf="showStrumentiUtili"
    [settingsStrumentiUtili]="settingsStrumentiUtili"
  ></app-strumenti-utili>
  <!-- TODO Cosa Puoi fare -->
</div>
